module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-Thin-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-Thin-webfont.eot
// module id = 687
// module chunks = 0